import {
  LazyLoadImage,
  LazyLoadComponent,
} from 'react-lazy-load-image-component';

export interface Card {
  title: string;
  href: string;
  date: string;
  datetime: string;
  image_url: string;
  new_tab: boolean;
}

interface Props {
  cards: Card[];
}

function truncateTitle(title: string | any[]) {
  if (title.length <= 55) {
    return title;
  }

  // Cut off at the last space within the limit
  let trimmedTitle = title.slice(0, 55);
  const lastSpaceIndex = trimmedTitle.lastIndexOf(' ');

  // Ensure we don't cut off in the middle of a word
  if (lastSpaceIndex !== -1) {
    trimmedTitle = trimmedTitle.slice(0, lastSpaceIndex);
  }

  return trimmedTitle + '...';
}


export default function CardGrid(props: Props) {

  return (
    <div className="relative bg-opacity-10 px-4 pb-20 sm:px-6 lg:px-8 lg:pb-28">
      <div className="absolute inset-0">
        <div className="h-1/3 sm:h-2/3" />
      </div>
      <div className="relative mx-auto max-w-7xl">
        {/* {(props.header || props.subheader) && (
          <div className="text-center">
            <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
              {props.header}
            </h2>
            <p className="mx-auto mt-3 max-w-2xl text-xl text-gray-500 sm:mt-4">
              {props.subheader}
            </p>
          </div>
        )} */}
        <div className="mx-auto mt-12 flex flex-wrap justify-center gap-5 max-w-6xl">
          {props.cards.map((card) => (
            <a
              href={card.href}
              target={card.new_tab ? '_blank' : ''}
              key={card.title}
              className="custom-a flex flex-col gap-0 overflow-hidden rounded-lg shadow-lg transition ease-in-out delay-50 hover:-translate-y-1 hover:scale-105 duration-300"
              rel="noopener noreferrer"
              style={{
                border: '1px solid #9CA3AF', // Tailwind gray-400 hex code
                borderRadius: '0.5rem',       // same as rounded-lg
              }}
            >
              <div
                className="flex-shrink-0"
                style={{
                  width: '340px',
                  marginBottom: '0', // Remove any spacing
                }}
              >
                <img
                  className="h-48 w-full object-cover"
                  src={card.image_url}
                  alt=""
                />
              </div>

              <div
                className="p-6 relative"
                style={{
                  height: '150px',
                  width: '340px',
                  marginTop: '0',
                  backgroundColor:'white'
                }}
              >
                <div className="text-center">
                  <p className="text-xl font-semibold text-black" style={{ marginBottom: 'unset' }}>
                    {truncateTitle(card.title)}
                  </p>
                </div>

                <div
                  className="absolute bottom-4 left-6 text-sm text-gray-400"
                >
                  <time dateTime={card.datetime}>
                    {new Date(card.datetime).toLocaleDateString('en-US', {
                      timeZone: 'America/New_York',
                      dateStyle: 'long',
                    })}
                  </time>
                </div>
              </div>

            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
